module.exports = __webpack_public_path__ + "img/41_53.61721045.png";